// Phone-sized screens get the mobile layout (mobile/MobileShell.tsx): a bottom tab bar, full-screen
// pages and bottom sheets instead of the rail, sidebar and pop-overs.
import { useSyncExternalStore } from 'react';

const QUERY = '(max-width: 767px)';
const mq = typeof window !== 'undefined' ? window.matchMedia(QUERY) : null;

function subscribe(cb: () => void) {
  mq?.addEventListener('change', cb);
  return () => mq?.removeEventListener('change', cb);
}

export function useIsMobile() {
  return useSyncExternalStore(subscribe, () => !!mq?.matches);
}
